<template>
    <div>
        <nav-bar />
        <!-- TODO: ハンバーガーメニュー表示制御 -->
        <aside-menu
            :menu="menu"
            style="left: 0px;"
            @open-modal="isContactModalOpen = true"
        />
        <team-activity />
        <main class="main">
            <router-view />
        </main>
        <footer-bar />
        <overlay
            v-show="isAsideLgActive"
            enable-scroll
            z-index="z-30"
            @overlay-click="overlayClick"
        />

        <contact-modal
            v-if="isContactModalOpen"
            @close="isContactModalOpen = false"
            @submit="isContactModalOpen = false"
        />
    </div>
</template>

<script setup>
import base from '@/api/base'
import AsideMenu from '@/components/Utilities/AsideMenu'
import ContactModal from '@/components/Utilities/ContactModal'
import FooterBar from '@/components/Utilities/FooterBar'
import NavBar from '@/components/Utilities/NavBar'
import Overlay from '@/components/Utilities/Overlay'
import TeamActivity from '@/components/Utilities/TeamActivity'
import menu from '@/menu.js'
import { computed, onMounted, ref, } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
// 初期アバター設定
store.commit('user', { avatar: 'img/no_user_avatar.png' })
const isAsideLgActive = computed(() => store.state.isAsideLgActive)
const overlayClick = () => {
    store.dispatch('asideLgToggle', false)
}
const isContactModalOpen = ref(false)

onMounted(async() => {
    const response = await base.get('session', {}, true)
    if (response) {
        store.commit('setBasicInfo', response)
    }
})
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap');
@import url("https://cdn.plyr.io/3.7.8/plyr.css");
body {
    font-family: 'Noto Sans JP', sans-serif !important;
}

.contact-field {
    height: 200px;
}

html, body {
    min-height: 100vh;
}

.main {
    min-height: calc(100vh - 120px);
    padding-left: 4rem !important;
}
</style>
